import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelClientsEditReferralResolverErrorStatesEnum {
    GetReferralProfileFailed = ErrorStateScheduleEnum.PanelClientsEditReferralResolverErrorStatesStartIndex
}
